<template>
  <div class="meta_box">
    <el-row :gutter="20">
      <el-col :xs="24"
        ><div class="descp1 vhtml_component" v-html="dataConfiguration.description1"></div>
        <br />
        <div class="descp2 vhtml_component" v-html="dataConfiguration.description2"></div>
      </el-col>
      <el-col :xs="24" class="button_box">
        <el-button class="el-button blue_button" data-testid="fund" @click="goToFund">
          {{ $t('promotion.depositBonus.fund') }}</el-button
        >
      </el-col>
      <el-col :xs="24" class="agreeTnc_box">
        <i18n path="promotion.depositBonus.tnc">
          <template v-slot:link>
            <a :href="dataConfiguration.tncLink" target="_blank" data-testid="tnc">
              {{ $t('promotion.depositBonus.link') }}
            </a>
          </template>
        </i18n>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import blackList from '@/mixins/blackList';
export default {
  name: 'fundAccount',
  mixins: [blackList],
  props: { dataConfiguration: {} },
  computed: {},
  methods: {
    goToFund() {
      this.getDepositBlacklist();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/promotion/clientPortalSettings.scss';
</style>
